module.exports = __webpack_public_path__ + "static/img/8.7d08ab5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/8.png
// module id = 8t0o
// module chunks = 0